var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.$vuetify.breakpoint.xsOnly ? 'overflow: hidden;' : null),attrs:{"id":"app-wrapper"}},[_c('app-header'),_c('v-main',[_c('router-view'),_c('snackbarNotifications')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }